import React, { Component } from "react";
// import { render } from "react-dom";
import axios from 'axios';
// import ReactDataGrid from "react-data-grid";
// import { Editors, Toolbar, Formatters } from 'react-data-grid-addons';
// import update from 'immutability-helper';
// import mainLogo from'./../_img/logo-csmile.png';
import Popup from './../PopUp/PopUpArcode';
import PopUpOther from './../PopUp/PopUpOther';

import SelectFix from './../PopUp/SelectFix';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
// import moment from 'moment';

//import Popup from'./../PopUp/Popup';
require('./style.css');



export default class header extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            H_Customercode: "",
            H_Customername: "",
            H_Datatype: "",
            H_Saledate: "",
            H_Deliveryno: "",
            H_Vat: "",
            H_Vatdate: "",
            H_Deliverytype: "",
            H_Creditcode: "",
            H_Patdue: "",
            H_Pricetype: "",
            H_Booktype: "",
            H_Carrylocation: "",
            C_txt1: "",

        };


    }


    valueChange = (data) => {

        switch (data.target.name) {
            case "H_Customercode": this.setState({ H_Customercode: data.target.value }); break;
            case "H_Customername": this.setState({ H_Customername: data.target.value }); break;
            case "H_Datatype": this.setState({ H_Datatype: data.target.value }); break;
            case "H_Saledate": this.setState({ H_Saledate: data.target.value }); break;
            case "H_Deliveryno": this.setState({ H_Deliveryno: data.target.value }); break;
            case "H_Vat": this.setState({ H_Vat: data.target.value }); break;
            case "H_Vatdate": this.setState({ H_Vatdate: data.target.value }); break;
            case "H_Deliverytype": this.setState({ H_Deliverytype: data.target.value }); break;
            case "H_Creditcode": this.setState({ H_Creditcode: data.target.value }); break;
            case "H_Patdue": this.setState({ H_Patdue: data.target.value }); break;
            case "H_Pricetype": this.setState({ H_Pricetype: data.target.value }); break;
            case "H_BookType": this.setState({ H_BookType: data.target.value }); break;
            case "H_Carrylocation": this.setState({ H_Carrylocation: data.target.value }); break;
        }
        setTimeout(() => {
            this.props.ReturnValue_H(this.state);

        }, 200);
    }

    Get_PopUparcode = (code, txtname) => {
        this.setState({ H_Customercode: code });
        this.setState({ H_Customername: txtname });
        this.setState({ showPopup: !this.state.showPopup });

        setTimeout(() => {
            this.props.ReturnValue_H(this.state);
        }, 200);
    }

    togglePopup() {
        this.setState({
            showPopup: !this.state.showPopup

        });


    }

    handleFocus(event) {
        event.target.select();
    }

    onKeyDown = (event) => {
        if (event.keyCode === 13) {
            if (event.target.value !== '') {
                if (event.target.name === 'H_Customercode') {
                    var ItemCode = event.target.value;
                    var Url = 'https://api1.pspl.co.th/CSOrderBook/ArCode?api_key=hqqng8R4nDb6jkHY9XxoJwmNKGIVzgTHvZCuxUaw&jwt=' + sessionStorage.getItem('Token') + '&arcode=' + ItemCode;

                    axios.get(Url).then(res => {

                        if (res.data.length !== 0) {
                            this.setState({ H_Customername: res.data[0].arname });
                        } else {
                            this.setState({ H_Customername: '' });
                            this.Alerttxt('ไม่พบข้อมูล');
                            //confirmAlert(options)
                        }
                    });

                } else if (event.target.name === 'H_Datatype') {
                    this.refs['H_Saledate'].focus();
                } else if (event.target.name === 'H_Saledate') {
                    this.refs['H_Deliveryno'].focus();
                } else if (event.target.name === 'H_Deliveryno') {
                    this.refs['H_Creditcode'].focus();
                } else if (event.target.name === 'H_Creditcode') {
                    this.refs['H_Pricetype'].focus();
                } else if (event.target.name === 'H_Pricetype') {
                    this.refs['H_Deliverytype'].focus();
                } else if (event.target.name === 'H_Deliverytype') {
                    this.refs['H_BookType'].focus();
                } else if (event.target.name === 'H_BookType') {
                    this.refs['H_Patdue'].focus();
                } else if (event.target.name === 'H_Patdue') {
                    this.refs['H_Carrylocation'].focus();
                }

            }
        }

    };


    mySubmit = (e) => {
        e.preventDefault();
        console.log(this.props.rows)
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    SetPopup = (data) => {
        this.setState({ PopUpTYpe: data });
        this.setState({ showPopupOT: !this.state.showPopupOT });
    }
    PopUpOtherClose = (data) => {
        this.setState({ showPopupOT: !this.state.showPopupOT });
    }
    Get_PopUpOther = (data) => {
        switch (this.state.PopUpTYpe) {
            case "Groupdata": this.setState({ H_Datatype: data }); this.refs['H_Datatype'].focus(); break;
            case "CreditCode": this.setState({ H_Creditcode: data }); this.refs['H_Creditcode'].focus(); break;
        }
        setTimeout(() => {
            this.props.ReturnValue_H(this.state);
        }, 200);
        this.setState({ showPopupOT: !this.state.showPopupOT });

    }
    SelectSetData = (type, data) => {
        switch (type) {
            case "PriceType": this.setState({ H_Pricetype: data }); break;
            case "BookType": this.setState({ H_BookType: data }); this.refs['H_BookType'].focus(); break;
            case "Calendar": this.setState({ H_Saledate: data }); break;
            case "Calendar1": this.setState({ H_Vatdate: data }); break;
            case "Calendar2": this.setState({ H_Patdue: data }); break;
        }
    }



    Alerttxt = (data) => {
        confirmAlert({
            title: '',
            message: data,
            buttons: [
                {
                    label: 'OK',
                    // onClick: () => alert('Click Yes')
                }
            ]
        })
    };

    render() {



        return (

            <div class="container" style={{ minHeight: this.props.HTop }}>
                <div class="cs-order-popup" >
                    {this.state.showPopup ? <Popup closePopup={this.togglePopup.bind(this)} Get_PopUparcode={this.Get_PopUparcode} /> : null}
                    {this.state.showPopupOT ? <PopUpOther closePopup={this.PopUpOtherClose} Get_PopUpOther={this.Get_PopUpOther} type={this.state.PopUpTYpe} /> : null}
                </div>




                <div class='row cs-order-book ' >
                    <div class='col-sm-12' >
                        <div class="input-group group-cus1">
                            <span class="input-group-addon">รหัสลูกค้า:&nbsp;&nbsp;</span>
                            <input type="text" class="form-control input-cus1" name="H_Customercode" value={this.state.H_Customercode} onKeyDown={this.onKeyDown} onChange={this.valueChange} />
                            <span class="input-group-addon txt-img"><i class="glyphicon glyphicon-user" ></i></span>
                        </div>
                        <div class="input-group group-cus3">
                            <div> </div>
                        </div>
                        <div class="input-group group-cus2">
                            <span class="input-group-addon txt-img"><i class="glyphicon glyphicon-search" onClick={this.togglePopup.bind(this)}></i></span>
                            <input readOnly type="text" class="form-control input-cus2" name="H_Customername" value={this.state.H_Customername} onChange={this.valueChange} />
                        </div>
                    </div>
                </div>

                <div class="container-fluid col-xs-12 col-sm-12  col-md-12 col-lg-6">
                    <hr />
                    <div class="row">
                        <div class="form-group col-xs-12 col-sm-6 col-lg-6 col-md-6">
                            <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span class="input-group-addon">รหัสสินค้า : </span>
                                <input id="itemcode" type="text" class="form-control " name="itemcode" onChange={this.inputonChange.bind(null, "itemcode")} tabIndex="1" />

                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-6 col-lg-6 col-md-6">
                            <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span class="input-group-addon">รหัสสินค้าเก่า : </span>
                                <input id="olditemcode" type="text" class="form-control " name="olditemcode" onChange={this.inputonChange.bind(null, "olditemcode")} tabIndex="2" />

                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                            <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span class="input-group-addon"> ชื่อสินค้าภาษาไทย :</span>
                                <input id="id1" type="text" class="form-control " onChange={this.inputonChange.bind(null, "THname")} tabIndex="3" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class='row cs-order-book'>
                    <div class='col-sm-4 '>
                        <div class="input-group group-custom">
                            <span class="input-group-addon">กลุ่มข้อมูล:&nbsp;&nbsp;</span>
                            <input onFocus={this.handleFocus} ref="H_Datatype" type="text" class="form-control input-custom" name="H_Datatype" value={this.state.H_Datatype} onChange={this.valueChange} onKeyDown={this.onKeyDown} />
                            <span class="input-group-addon txt-img" onClick={this.SetPopup.bind(null, 'Groupdata')}><i class="fas fa-search"></i></span>
                        </div>
                    </div>
                    <div class='col-sm-4 '>
                        <div class="input-group group-custom">
                            <span class="input-group-addon">วันที่จอง:&nbsp;&nbsp;</span>
                            <input onFocus={this.handleFocus} ref="H_Saledate" type="text" class="form-control input-custom" name="H_Saledate" value={this.state.H_Saledate} onChange={this.valueChange} onKeyDown={this.onKeyDown} />
                            <span class="input-group-addon txt-img"><SelectFix type={"Calendar"} SelectSetData={this.SelectSetData} /></span>
                        </div>
                    </div>
                    <div class='col-sm-4 '>
                        <div class="input-group group-custom">
                            <span class="input-group-addon">เลขที่ใบจอง:&nbsp;&nbsp;</span>
                            <input onFocus={this.handleFocus} ref="H_Deliveryno" type="text" class="form-control input-custom" name="H_Deliveryno" value={this.state.H_Deliveryno} onChange={this.valueChange} onKeyDown={this.onKeyDown} />
                            <span class="input-group-addon txt-img"><i class="glyphicon glyphicon-circle-arrow-up" ></i></span>
                        </div>
                    </div>
                </div>

                <div class='row cs-order-book'>
                    <div class='col-sm-4 '>
                        <div class="input-group group-custom">
                            <span class="input-group-addon">รหัสเครดิต:&nbsp;&nbsp;</span>
                            <input onFocus={this.handleFocus} ref="H_Creditcode" type="text" class="form-control input-custom" name="H_Creditcode" value={this.state.H_Creditcode} onChange={this.valueChange} onKeyDown={this.onKeyDown} />
                            <span class="input-group-addon txt-img" onClick={this.SetPopup.bind(null, 'CreditCode')}><i class="fas fa-search"></i></span>
                        </div>
                    </div>
                    <div class='col-sm-4 '>
                        <div class="input-group group-custom">
                            <span class="input-group-addon">ประเภทราคา:&nbsp;&nbsp;</span>
                            <input onFocus={this.handleFocus} ref="H_Pricetype" type="text" class="form-control input-custom" name="H_Pricetype" value={this.state.H_Pricetype} onChange={this.valueChange} onKeyDown={this.onKeyDown} />
                            <span class="input-group-addon txt-img"><SelectFix type={"PriceType"} SelectSetData={this.SelectSetData} /></span>
                        </div>
                    </div>
                    <div class='col-sm-4 '>
                        <div class="input-group group-custom">
                            <span class="input-group-addon">การส่งมอบ:&nbsp;&nbsp;</span>
                            <input onFocus={this.handleFocus} ref="H_Deliverytype" type="text" class="form-control input-custom" name="H_Deliverytype" value={this.state.H_Deliverytype} onChange={this.valueChange} onKeyDown={this.onKeyDown} />
                            <span class="input-group-addon txt-img"><i class="fas fa-caret-down" ></i></span>
                        </div>
                    </div>
                </div>

                <div class='row cs-order-book'>
                    <div class='col-sm-4 '>
                        <div class="input-group group-custom">
                            <span class="input-group-addon">ประเภทการจอง:&nbsp;&nbsp;<div id="Test113"></div></span>
                            <input onFocus={this.handleFocus} ref="H_BookType" type="text" class="form-control input-custom" name="H_BookType" value={this.state.H_BookType} onChange={this.valueChange} onKeyDown={this.onKeyDown} />
                            <span class="input-group-addon txt-img"><SelectFix type={"BookType1"} SelectSetData={this.SelectSetData} /></span>
                        </div>
                    </div>
                    <div class='col-sm-4 '>
                        <div class="input-group group-custom">
                            <span class="input-group-addon">นัดส่งมอบ:&nbsp;&nbsp;</span>
                            <input onFocus={this.handleFocus} ref="H_Patdue" type="text" class="form-control input-custom" name="H_Patdue" value={this.state.H_Patdue} onChange={this.valueChange} onKeyDown={this.onKeyDown} />
                            <span class="input-group-addon txt-img"><SelectFix type={"Calendar2"} SelectSetData={this.SelectSetData} /></span>
                        </div>
                    </div>
                    <div class='col-sm-4 '>
                        <div class="input-group group-custom">
                            <span class="input-group-addon">สถานที่ส่ง:&nbsp;&nbsp;</span>
                            <input onFocus={this.handleFocus} ref="H_Carrylocation" type="text" class="form-control input-custom" name="H_Carrylocation" value={this.state.H_Carrylocation} onChange={this.valueChange} onKeyDown={this.onKeyDown} />
                            <span class="input-group-addon txt-img"><SelectFix type={"H_Carrylocation"} SelectSetData={this.SelectSetData} /></span>
                        </div>
                    </div>
                </div>

            </div >
        );
    }
}